import BaseModel from "../../base/baseModel";

import InformacoesNfeModel from "./informacoes/informacoesNfeModel";

export default class DadosNfeModel extends BaseModel {
    informacoes: InformacoesNfeModel = new InformacoesNfeModel();
}
